import { useSearchParams } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Box, Card, Flex, Text, Heading } from "@radix-ui/themes";

export default function SubscriptionCancelledPage() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");
  const reason = searchParams.get("reason");

  return (
    <Box
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "var(--gray-2)",
        padding: "2rem",
      }}
    >
      <Card size="4" style={{ maxWidth: "600px", width: "100%" }}>
        <Flex direction="column" gap="6" align="center" p="6">
          <Box>
            <XCircle size={80} color="var(--orange-9)" strokeWidth={1.5} />
          </Box>
          <Flex direction="column" gap="3" align="center">
            <Heading size="6" weight="bold">
              Subscription Setup Cancelled
            </Heading>
            <Text size="3" color="gray" align="center">
              Your subscription setup was cancelled and no charges were made.
            </Text>
          </Flex>
          {(sessionId || reason) && (
            <Card variant="surface" style={{ width: "100%" }}>
              <Flex direction="column" gap="3" p="4">
                <Text size="2" weight="bold" color="gray">
                  Details
                </Text>
                {sessionId && (
                  <Flex gap="2" align="center">
                    <Text size="2" color="gray">
                      Session ID:
                    </Text>
                    <Text size="2" style={{ fontFamily: "monospace" }}>
                      {sessionId}
                    </Text>
                  </Flex>
                )}
                {reason && (
                  <Flex gap="2" align="center">
                    <Text size="2" color="gray">
                      Reason:
                    </Text>
                    <Text size="2">{reason}</Text>
                  </Flex>
                )}
              </Flex>
            </Card>
          )}
          <Text size="2" color="gray" align="center" mt="4">
            You can safely close this window.
          </Text>
        </Flex>
      </Card>
    </Box>
  );
}
